import { Component, OnInit } from '@angular/core';
import { ShippingMethodsService } from '../shipping-methods.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddOrEditShippingMethodComponent } from '../add-or-edit-shipping-method/add-or-edit-shipping-method.component';
import { DialogService } from '../../common/dialog.service';
import { HttpErrorHandler } from '../../common/httpErrorHandler';

@Component({
  selector: 'app-shipping-methods',
  templateUrl: './shipping-methods.component.html',
  styleUrls: ['./shipping-methods.component.less']
})
export class ShippingMethodsComponent implements OnInit {
  data: any = {
    records: []
  };
  id: number;
  model: any = {
    page: 1,
    size: 10,
    term: null
  };

  constructor(
    private service: ShippingMethodsService,
    private modalService: NgbModal,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.load();
  }

  load() {
    this.service.getAll(this.model)
      .subscribe(methods => {
        this.data = methods;
      });
  }

  search() {
    this.model.page = 1;
    this.load();
  }

  clear() {
    this.model.page = 1;
    this.model.term = null;
    this.load();
  }

  openModal(id) {
    const modalRef = this.modalService.open(AddOrEditShippingMethodComponent);
    modalRef.componentInstance.id = id;
    modalRef.result.then(result => {
      if (!!result) {
        this.data = [];
        this.load();
      }
    });
  }

  openDeleteModal(id) {
    this.dialogService.confirmDialog('Are you sure you want to delete this shipping method?')
      .then(result => {
        if (!!result) {
          this.service.deleteShippingMethod(id)
            .subscribe(methods => {
              this.data = [];
              this.load();
              this.dialogService.successMessage('Shipping method successfully deleted!');
            }, error => {
              this.dialogService.errorMessage(HttpErrorHandler.retrieveErrorsAsSingleMessage(error));
            });
        }
      });
  }

}
